import React from 'react';
import { Box, Flex, Text, Spinner, Center } from '@chakra-ui/react';
import { useQuery, gql } from '@apollo/client';

const GET_WEATHER_DATA = gql`
  query GetWeatherData {
    getWeatherData {
      temperature
      humidity
      wind_speed
      wind_speed_avg
      wind_gust
      wind_direction_text
      barometric_pressure
      pressure_trend
      heat_index
      wind_chill
      rain_rate
      rain_today
      last_updated_formatted
    }
  }
`;

export const WeatherWidget = () => {
  const { loading, error, data } = useQuery(GET_WEATHER_DATA, {
    pollInterval: 600000, // Refresh every 10 minutes
  });

  if (loading) {
    return (
      <Box bg="#2D3748" py={3}>
        <Center>
          <Spinner color="white" size="sm" />
        </Center>
      </Box>
    );
  }

  if (error || !data?.getWeatherData) {
    return null;
  }

  const w = data.getWeatherData;
  const feelsLike = w.temperature > 80 ? w.heat_index : w.wind_chill;

  return (
    <Box
      bg="#2D3748"
      py={{ base: 3, md: 3 }}
      px={{ base: '24px', md: '84px' }}
      color="white"
    >
      <Flex
        align="center"
        justify="space-between"
        gap={{ base: 3, md: 6 }}
        flexWrap={{ base: 'wrap', md: 'nowrap' }}
      >
        {/* Temperature + Location */}
        <Flex align="center" gap={4}>
          <Flex align="baseline" gap={0}>
            <Text fontSize={{ base: '36px', md: '44px' }} fontWeight="700" lineHeight="1">
              {Math.round(w.temperature)}
            </Text>
            <Text fontSize={{ base: '18px', md: '22px' }} opacity={0.85}>°F</Text>
          </Flex>
          <Box>
            <Text fontSize={{ base: '13px', md: '14px' }} fontWeight="600" color="#FD5521">
              Golden Gun Club
            </Text>
            <Text fontSize={{ base: '11px', md: '12px' }} opacity={0.7}>
              Feels like {Math.round(feelsLike)}°F
            </Text>
          </Box>
        </Flex>

        {/* Metrics */}
        <Flex
          gap={{ base: 4, md: 8 }}
          flexWrap="wrap"
          justify={{ base: 'space-around', md: 'flex-end' }}
          w={{ base: '100%', md: 'auto' }}
        >
          <MetricItem label="Wind" value={`${Math.round(w.wind_speed)} mph`} sub={w.wind_direction_text} />
          <MetricItem label="Gusts" value={`${Math.round(w.wind_gust)} mph`} />
          <MetricItem label="Humidity" value={`${w.humidity}%`} />
          <MetricItem label="Pressure" value={w.barometric_pressure?.toFixed(2)} sub={w.pressure_trend} />
          {w.rain_today > 0 && (
            <MetricItem label="Rain Today" value={`${w.rain_today} in`} />
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

const MetricItem = ({ label, value, sub }) => (
  <Box textAlign="center" minW="70px">
    <Text fontSize="10px" opacity={0.6} textTransform="uppercase" letterSpacing="0.5px" mb="2px">
      {label}
    </Text>
    <Text fontSize={{ base: '15px', md: '18px' }} fontWeight="600">
      {value}
    </Text>
    {sub && (
      <Text fontSize="10px" opacity={0.6}>{sub}</Text>
    )}
  </Box>
);
